import L from "leaflet";
import 'leaflet-polylinedecorator';

// Rijrichting-pijlen op een route (VTT-1804). De richting zelf zit in de
// puntvolgorde van de GPX; dit is enkel de visualisatie ervan.
export function createDirectionDecorator(layer, color) {
    return L.polylineDecorator(layer, {
        patterns: [{
            offset: 25,
            repeat: 80,
            symbol: L.Symbol.arrowHead({
                pixelSize: 12,
                polygon: false,
                pathOptions: {
                    stroke: true,
                    color: color,
                    weight: 3,
                    interactive: false,
                    pmIgnore: true
                }
            })
        }]
    });
}
